/** Campaign lifecycle states. */
export enum CampaignStatus {
	DRAFT = 'draft',
	IN_PROGRESS = 'in_progress',
	IN_REVIEW = 'in_review',
	APPROVED = 'approved',
	LIVE = 'live',
	ARCHIVED = 'archived',
}
